import { render, staticRenderFns } from "./DIAGAdocaoSistema.vue?vue&type=template&id=76396777&scoped=true&"
import script from "./DIAGAdocaoSistema.vue?vue&type=script&lang=js&"
export * from "./DIAGAdocaoSistema.vue?vue&type=script&lang=js&"
import style0 from "./DIAGAdocaoSistema.vue?vue&type=style&index=0&id=76396777&prod&scoped=true&lang=css&"
import style1 from "./DIAGAdocaoSistema.vue?vue&type=style&index=1&id=76396777&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76396777",
  null
  
)

export default component.exports